export default "__VITE_ASSET__8f7b2d63__"